import { useState } from 'react';
import ConsultingFormModal from '../../../components/ConsultingFormModal';

export default function USPComparison() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const comparisons = [
    {
      feature: "견적 발송 속도",
      others: "영업일 기준 7~10일 소요",
      us: "3영업일 이내 빠른 발송"
    },
    {
      feature: "컨설팅 전문성",
      others: "일반적인 컨설팅 제공",
      us: "업종별 맞춤형 전문 컨설팅"
    },
    {
      feature: "사후관리",
      others: "컨설팅 종료 후 관리 없음",
      us: "감독 대응 증빙자료 지속 관리"
    },
    {
      feature: "무료 자료 제공",
      others: "유료 또는 제공 없음",
      us: "2026년 최신 감독 지적 사례집 무료 제공"
    }
  ];

  return (
    <>
      <section className="py-12 md:py-24 bg-gradient-to-b from-white to-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4 md:mb-6 px-4">
              왜 중대안전보건예방협회를 선택해야 할까요?
            </h2>
            <p className="text-base md:text-xl text-slate-600 max-w-3xl mx-auto">
              다른 업체와 비교해보세요
            </p>
          </div>

          <div className="max-w-6xl mx-auto">
            {/* 모바일 버전 - 병합된 카드 */}
            <div className="md:hidden">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 border-2 border-blue-600 shadow-lg">
                <div className="space-y-6">
                  {comparisons.map((item, index) => (
                    <div key={index} className="pb-6 border-b border-blue-200 last:border-b-0 last:pb-0">
                      <h4 className="text-xs font-bold text-blue-900 mb-3">{item.feature}</h4>
                      <div className="space-y-2">
                        <div className="bg-white/50 rounded-lg p-3">
                          <p className="text-xs text-slate-500 mb-1">타 기관</p>
                          <p className="text-slate-600 text-sm leading-relaxed">{item.others}</p>
                        </div>
                        <div className="bg-blue-600 rounded-lg p-3">
                          <p className="text-xs text-blue-200 mb-1">중대안전보건예방협회</p>
                          <p className="text-white text-sm leading-relaxed font-medium">{item.us}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* PC 버전 - 기존 두 카드 */}
            <div className="hidden md:grid grid-cols-2 gap-6">
              {/* 타 기관 카드 */}
              <div className="bg-slate-50 rounded-2xl p-8 border-2 border-slate-200 shadow-md">
                <h3 className="text-3xl font-bold text-slate-600 mb-8 text-center">타 기관</h3>
                <div className="space-y-6">
                  {comparisons.map((item, index) => (
                    <div key={index} className="pb-6 border-b border-slate-200 last:border-b-0 last:pb-0">
                      <h4 className="text-sm font-bold text-slate-500 mb-2">{item.feature}</h4>
                      <p className="text-slate-600 text-lg leading-relaxed">{item.others}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* 중대안전보건예방협회 카드 */}
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 border-2 border-blue-600 shadow-lg">
                <h3 className="text-3xl font-bold text-blue-600 mb-8 text-center">중대안전보건예방협회</h3>
                <div className="space-y-6">
                  {comparisons.map((item, index) => (
                    <div key={index} className="pb-6 border-b border-blue-200 last:border-b-0 last:pb-0">
                      <h4 className="text-sm font-bold text-blue-900 mb-2">{item.feature}</h4>
                      <p className="text-blue-900 text-lg font-semibold leading-relaxed">{item.us}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Bottom Highlight Card */}
            <div className="mt-12 md:mt-20">
              <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-6 md:p-8 lg:p-10 shadow-2xl border-2 border-blue-800 max-w-full mx-auto">
                <div className="text-center">
                  <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-white mb-2">
                    차별화된 서비스로 고객 만족도 1위
                  </h3>
                  <p className="text-sm md:text-base text-white leading-relaxed font-semibold mb-4 md:mb-6">
                    전문성과 신뢰를 바탕으로 최고의 컨설팅을 제공합니다
                  </p>
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="bg-white text-blue-600 px-6 md:px-8 py-2.5 md:py-3 rounded-lg font-bold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer shadow-lg text-sm md:text-base"
                  >
                    무료 견적 받기
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ConsultingFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
